import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Image } from 'react-bootstrap';
import { StringParam } from 'use-query-params';
import searchIcon from 'Static/Images/search-icon.svg';
import DownIcon from 'Static/Images/down-icon.svg';
import { InputSearchProps } from './ISearch';

const InputSearch = forwardRef<{ handleSetQuery: (query: string) => void }, InputSearchProps>(
  (
    {
      placeholder,
      params,
      setShow,
      onEnter,
      value,
      setValue,
      showIcon = true,
      isDisabled,
      onFocusInput,
    }: InputSearchProps,
    ref,
  ): JSX.Element => {
    const objParams = { ...params };
    Object.keys(objParams).map((key) => {
      objParams[key] = StringParam;
    });

    const handleOnchange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setValue(value);
    };

    useImperativeHandle(ref, () => ({
      handleSetQuery(query: string) {
        setValue(query);
      },
    }));

    return (
      <>
        <div className="position-relative input-search-wrapper">
          {showIcon && <Image src={searchIcon} className="icon-search position-absolute" />}
          <Form.Control
            disabled={isDisabled}
            className={`${showIcon && 'ps-30'} input-search`}
            onFocus={(e) => {
              setShow(true);
              onFocusInput && onFocusInput(e);
            }}
            value={value ?? ''}
            onChange={handleOnchange}
            placeholder={placeholder}
            onKeyDown={(e: any) => {
              onEnter(e);
            }}
            type="search"
          />
          <Image src={DownIcon} className="icon-down position-absolute" />
        </div>
      </>
    );
  },
);

export default InputSearch;
